<template>
  <div class="wrapper">
    <div class="title">{{ $t("game.instructionsView.title") }}</div>
    <img src="@/assets/images/img/game-instructions.png" :alt="$t('game.instructionsView.altText')" />
  </div>
</template>
